// removed by extract-text-webpack-plugin
module.exports = {"article-image-wrapper":"main_nav-3f5","article-image-header":"main_nav-ruG","article-image-figure":"main_nav-T4n","article-image":"main_nav-3Qc"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Submenu/ArticleImage/article_image.module.scss
// module id = 355
// module chunks = 0